import { render, staticRenderFns } from "./LogementForm.vue?vue&type=template&id=4ad896ac&scoped=true"
import script from "./LogementForm.vue?vue&type=script&lang=js"
export * from "./LogementForm.vue?vue&type=script&lang=js"
import style0 from "./LogementForm.vue?vue&type=style&index=0&id=4ad896ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad896ac",
  null
  
)

export default component.exports